import CheckoutNavbar from './components/CheckoutNavbar';
import GetAllOp from './components/GetAllOp';
import GetSetting from './components/GetSetting';


const CheckOutSetting = () => {
     return (
          <>
               <CheckoutNavbar />
               <GetAllOp />
               <GetSetting />
          </>
     )
}
export default CheckOutSetting